import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const navLinks = [{
  label: 'Inicio',
  href: '#inicio'
}, {
  label: 'Ciencia',
  href: '#ciencia'
}, {
  label: 'Beneficios',
  href: '#beneficios'
}, {
  label: 'Testimonios',
  href: '#testimonios'
}, {
  label: 'Protocolo',
  href: '#protocolo'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
  };
  return <nav className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-dark/95 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-5 mt-8'}`} data-id="element-112">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-113">
        <div className="flex justify-between items-center" data-id="element-114">
          <div className="flex-shrink-0" data-id="element-115">
            <img src="https://cdn.shopify.com/s/files/1/0976/6528/6457/files/althypro_400_x_120_px_blanco.png?v=1768000809" alt="Althypro Logo" className="h-8 md:h-10 w-auto" data-id="element-116" />
          </div>

          <div className="hidden md:flex items-center space-x-6" data-id="element-117">
            {navLinks.map(link => <a key={link.href} href={link.href} className="text-gray-300 hover:text-white text-sm font-medium transition-colors duration-200" data-id="element-118">
                {link.label}
              </a>)}
            <a href="#comprar" className="bg-pink-brand hover:bg-pink-brand/90 text-white px-6 py-2.5 rounded-full font-medium transition-colors duration-200" data-id="element-119">
              Comprar Ahora
            </a>
          </div>

          <div className="md:hidden flex items-center" data-id="element-120">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white hover:text-pink-brand transition-colors" aria-label="Toggle menu" data-id="element-121">
              {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-122" /> : <MenuIcon className="h-6 w-6" data-id="element-123" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-dark-surface border-t border-dark-card absolute top-full left-0 w-full shadow-xl" data-id="element-124">
          <div className="px-4 pt-4 pb-6 space-y-1" data-id="element-125">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={handleLinkClick} className="block px-4 py-3 text-gray-300 hover:text-white hover:bg-dark-card rounded-xl text-base font-medium transition-colors duration-200" data-id="element-126">
                {link.label}
              </a>)}
            <div className="pt-3" data-id="element-127">
              <a href="#comprar" onClick={handleLinkClick} className="block w-full text-center bg-pink-brand text-white px-6 py-3 rounded-full font-medium" data-id="element-128">
                Comprar Ahora
              </a>
            </div>
          </div>
        </div>}
    </nav>;
}